function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
function guid() {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
class EventManager{
    id= S4() + "-" + S4()
    constructor (){
        this.eventMap = {}
    }

    addEventListener(eventName, cb) {
        if (('string' === typeof eventName) && ('function' === typeof cb)) {
            this.eventMap[eventName] = this.eventMap[eventName] || []
            this.eventMap[eventName].push(cb)
        } else {
            console.warn('参数错误')
        }
    }

    fire(eventName, data){
        const cbList = this.eventMap[eventName]
        if (cbList) {
            cbList.forEach(cb => {
                cb(data)
            })
        }
    }
}

export default EventManager